//left in for ajax / anything else that
//is using jquery
var $body = $('.js-body');

const body = document.querySelector(".js-body"),
    stickyHeader = document.querySelector(".js-sticky-header"),
    galleryItems = document.querySelectorAll('.js-gallery-item'),
    fdthHeroScrollButton = document.querySelector(".js-fdth-hero-scroll-button"),
    fdthHeroScrollTarget = document.querySelector(".js-fdth-hero-scroll-target"),
    openingDate = document.querySelector('.js-opening-date');
    //   thisPage = body.dataset.page,
    //   site = body.dataset.site;

let width = window.innerWidth,
    height = window.innerHeight,
    scrollPos = 0;
